/**
 *
 * @param quantity
 */
export function itemQuantity(quantity: any): number {
    quantity = quantity || 0;
    return Math.max(quantity, 1);
}
